<template>
  <div class="main-layout">

    <NavbarAdmin v-if="user && user.role === 'admin'"/>
    <NavbarNormalUser v-else-if="user && user.role === 'normaluser'"/>

    <!--<navbar/>-->

    <div class="container-fluid mt-4">
      <child/>
    </div>
  </div>
</template>

<script>
  import NavbarAdmin from '~/components/menu/NavbarAdmin'
  import {mapGetters} from 'vuex'
  import NavbarNormalUser from "../components/menu/NavbarNormalUser";

  export default {
    name: 'MainLayout',
    props: {
      typeuser: {type: String, default: 'normaluser'},
    },
    components: {
      NavbarNormalUser,
      NavbarAdmin,
    },
    computed: mapGetters({
      user: 'auth/user',
    }),
    mounted: function () {
    }
  }
</script>
